<template>
  <div class="container-fluid px-0">
    <div class="row mb-4 g-2">
      <div class="col-6 col-md-2 col-lg-2">
        <input type="date" class="form-control form-control-sm" v-model="filters.date" @change="applyFilters" />
      </div>

      <div class="col-6 col-md-2 col-lg-2">
        <select class="form-select form-select-sm" v-model="filters.status" @change="applyFilters">
          <option value="">{{ $t('teacherLessons.allStatuses') }}</option>
          <option value="attended">{{ $t('teacherLessons.attended') }}</option>
          <option value="absent">{{ $t('teacherLessons.absent') }}</option>
          <option value="cancelled">{{ $t('teacherLessons.cancelled') }}</option>
        </select>
      </div>

      <div class="col-md-1 d-none d-md-block">
        <button class="btn btn-outline-secondary btn-sm w-100" @click="resetFilters" :title="$t('common.reset')">
          <i class="fas fa-filter-circle-xmark"></i>
        </button>
      </div>

      <div class="col-12 d-md-none">
        <button class="btn btn-outline-secondary btn-sm w-100" @click="resetFilters">
          <i class="fas fa-filter-circle-xmark"></i> {{ $t('common.reset') }}
        </button>
      </div>

      <div class="col-12 col-md-3 col-lg-3">
        <router-link to="/teacher-lessons/record" class="btn btn-secondary btn-sm w-100" v-can="'teacher_lessons.create'">
          <i class="fas fa-plus"></i>
          {{ $t('teacherLessons.recordLessons') }}
        </router-link>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, defineEmits, onMounted } from 'vue';

const emit = defineEmits(['filter']);

// Default to today's date instead of empty — otherwise every time this page
// is (re)mounted (e.g. after recording today's lessons and navigating back)
// the date filter silently resets and the list shows every lesson ever
// recorded instead of just today's.
const todayStr = () => new Date().toISOString().slice(0, 10);

const filters = ref({ date: todayStr(), status: '' });

const applyFilters = () => emit('filter', filters.value);
const resetFilters = () => {
  filters.value = { date: '', status: '' };
  emit('filter', filters.value);
};

// Emit the default (today) filter immediately so the parent's initial fetch
// uses it too, instead of fetching with its own empty default first.
onMounted(() => {
  emit('filter', filters.value);
});
</script>
